var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import ContractSVG from '@spa/shared/svg/contract';
import { Wrapper, Item, ItemDescription } from './styles';
import CancellationSVG from '@spa/shared/svg/cancellation';
import RegistrationSVG from '@spa/shared/svg/registration';
import { CONTRACTS } from '@spa/offer/constants/contracts';
import { REGISTRATION } from '@spa/shared/constants/registration';
import ArrowLink from '@spa/shared/components/Unisystem/ArrowLink';
import { CANCELLATIONS } from '@spa/shared/constants/cancellations';
import { Tooltip } from '@spa/shared/components';
import Exclamation from '@spa/shared/svg/exclamation';
import { theme } from '@spa/offer/theme';
import { trackHelpCenter } from '@spa/offer/store/actions/tracking';
var HELP_LINKS = {
  CANCELLATION_POLICIES: 'cancellation policies',
  CONTRACT_TYPES: 'more about the contract'
};
var Contract = function Contract(_ref) {
  var _REGISTRATION$country;
  var contractType = _ref.contractType,
    cancellationType = _ref.cancellationType,
    hasRegistration = _ref.hasRegistration,
    country = _ref.country,
    trackHelpCenterAction = _ref.trackHelpCenterAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var contract = CONTRACTS[contractType];
  var cancellation = CANCELLATIONS[cancellationType];
  var countryRegistration = (_REGISTRATION$country = REGISTRATION[country]) !== null && _REGISTRATION$country !== void 0 ? _REGISTRATION$country : t('Registration possible');
  var languagePath = language === 'en' ? '' : "".concat(language, "/");
  return __jsx(Wrapper, {
    id: 'Contract'
  }, __jsx("h2", null, t('Contract')), __jsx(Item, null, __jsx("div", null, __jsx(CancellationSVG, null)), __jsx(ItemDescription, null, __jsx("h4", null, t(cancellation.title), __jsx(Tooltip, {
    bottom: false
  }, __jsx(Exclamation, {
    color: theme.tooltip.iconColor
  }), __jsx("p", null, t('Uniplaces uses the contract start date and not the move-in date to calculate how many days are applied in the policy.')))), __jsx("p", null, t(cancellation.description)), __jsx(ArrowLink, {
    href: process.env.CANCELLATION_POLICIES_URL,
    text: t('More about our cancellation policies'),
    onClick: function onClick() {
      return trackHelpCenterAction(HELP_LINKS.CANCELLATION_POLICIES);
    }
  }))), __jsx(Item, null, __jsx("div", null, __jsx(ContractSVG, null)), __jsx(ItemDescription, null, __jsx("h4", null, t(contract.title)), __jsx("p", null, t(contract.description)), __jsx(ArrowLink, {
    href: "".concat(process.env.APP_URL).concat(languagePath, "contract-types/").concat(contract.urlPath),
    text: t('More about the contract'),
    onClick: function onClick() {
      return trackHelpCenterAction(HELP_LINKS.CONTRACT_TYPES);
    }
  }))), hasRegistration ? __jsx(Item, null, __jsx("div", null, __jsx(RegistrationSVG, null)), __jsx(ItemDescription, null, __jsx("h4", null, t('Registration possible')), __jsx("p", null, t('You can get registered on this place'), " (", countryRegistration, ")."))) : null);
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _documentation$offici;
  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate,
    _ref2$offer$offerAggr2 = _ref2$offer$offerAggr.accommodation_offer,
    type = _ref2$offer$offerAggr2.contract.type,
    cancellation_policy = _ref2$offer$offerAggr2.requisites.conditions.cancellation_policy,
    _ref2$offer$offerAggr3 = _ref2$offer$offerAggr.property_aggregate.property,
    documentation = _ref2$offer$offerAggr3.documentation,
    city_code = _ref2$offer$offerAggr3.location.address.city_code;
  return {
    contractType: type.split('-')[0],
    cancellationType: cancellation_policy,
    hasRegistration: !!(documentation !== null && documentation !== void 0 && (_documentation$offici = documentation.official_registration) !== null && _documentation$offici !== void 0 && _documentation$offici.enabled),
    country: city_code.split('-')[0]
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackHelpCenterAction: function trackHelpCenterAction(destination) {
      return dispatch(trackHelpCenter({
        destination: destination
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Contract);